import { render, staticRenderFns } from "./BuyForm.vue?vue&type=template&id=680b8f5a"
import script from "./BuyForm.vue?vue&type=script&lang=js"
export * from "./BuyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports